// src/stores/footerActions.store.ts
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

type Action = (() => void | Promise<void>) | null

export const useFooterActionsStore = defineStore('footerActions', () => {
  const onSave = ref<Action>(null)
  const onCancel = ref<Action>(null)
  const isSaveAction = ref(false)
  const saving = ref(false)

  const hasSave = computed(() => typeof onSave.value === 'function')
  const hasCancel = computed(() => typeof onCancel.value === 'function')

  function setActions(actions: { onSave?: Action; onCancel?: Action }, saveAction = false) {
    if ('onSave' in actions) onSave.value = actions.onSave ?? null
    if ('onCancel' in actions) onCancel.value = actions.onCancel ?? null
    isSaveAction.value = saveAction
  }

  function clear() {
    onSave.value = null
    onCancel.value = null
    saving.value = false
    isSaveAction.value = false
  }

  async function runSave() {
    if (!onSave.value) return
    saving.value = true
    try {
      await onSave.value()
    } finally {
      saving.value = false
    }
  }

  async function runCancel() {
    if (!onCancel.value) return
    await onCancel.value()
  }

  return { setActions, clear, runSave, runCancel, saving, hasSave, hasCancel, isCreateAction: isSaveAction }
})
